import { render, staticRenderFns } from "./IntentForward.vue?vue&type=template&id=c5a3c2bc&"
import script from "./IntentForward.vue?vue&type=script&lang=js&"
export * from "./IntentForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports